import { Component } from '.';
import { TransformPosition, TransformRotation } from '../../interfaces';

export class Point extends Component {
	public state: {
		position: TransformPosition;
		rotation?: TransformRotation;
	} = { position: { x: 0, y: 0, z: 0 } };

	public getDistanceTo: (position: TransformPosition) => number;
	public getWorldPosition: () => TransformPosition;
}
